/*This is the application configuration reducer.
 *This is where the default settings for the app are stored as state
 *And updated when required.
 * @author Adam Kale @ Pufferfish Limited.
 */
import * as actionNames from "../actions/ActionTypes.js";

const initialState = {
  apps: [],
  favoriteApps: [],
  currentAppName: "",
  defaultAppName: "",
  uploadActive: false,
  uploadProgress: 0,
};

/// <summary>
//For each action type this reducer will update it's own state.
//In some cases it will call functions in other classes to pull data
//into its own state values.  This is so that any component can have access
//to any of these states but can not change them.
//Keep in mind that states should never be mutated as they are immutable.
//Always do: state = {...state, valueToUpdate: newValue}  - Never: state.valueToUpdate = newValue.
//<param name="action">the action passed from the actions.js/param>
/// </summary>
export default function AppsCollection(state = initialState, action) {
  switch (action.type) {
    case actionNames.SET_APPS_LIST:
      state = { ...state, apps: action.payload };
      break;
    case actionNames.SET_FAVORITEAPPS_LIST:
      state = { ...state, favoriteApps: action.payload };
      break;
    case actionNames.SET_CURRENT_APP_NAME:
      state = { ...state, currentAppName: action.payload };
      break;
    case actionNames.SET_DEFAULT_APP_NAME:
      state = { ...state, defaultAppName: action.payload };
      break;
    case actionNames.SET_UPLOAD_ACTIVE:
      state = { ...state, uploadActive: action.payload };
      break;
    case actionNames.SET_UPLOAD_PROGRESS:
      state = { ...state, uploadProgress: action.payload };
      break;
    default:
      return state;
  }
  return state;
}
